import React, { useState, useEffect, useRef } from "react";
import ToolTip from "./ToolTipComponent";
import {
  addOpacityToHex,
  getInitials,
  isObjectInArray,
  isObjectInArray2,
  predefinedColors,
} from "../../utils/utilityFunctions/stringUtility";
import withPortalHOC from "./WithPortalHOC";
import InputComponent from "./InputComponent";
import Button from "./DefaultButton";
import { useEditTagMutation } from "../../utils/customer/customerSelect";
import useRequireAuth from "../../utils/useRequireAuth";
import FloatingList from "./FloatingElement";
import CircularLoader from "./CircularLoader";
import ToggleButton from "./ToggleButtons";
import ToggleSwitch from "./ToggleSwitch";

import { ReactComponent as SearchIconGray } from "../../assets/images/icons/SearchIconGray.svg";
import AvatarName from "./AvatarName";
import Checkbox from "./CheckBox";
import { ReactComponent as RightArrowIcon } from "../../assets/images/icons/RightArrowInCircle.svg";
import { ReactComponent as PlusIcon } from "../../assets/images/icons/PlusIconPlain.svg";
import {
  addMissingFilteredToSelected,
  listsExactlyMatchByKey,
  removeFilteredFromSelected,
} from "../../utils/utilityFunctions/selectComponent";
import ToolTipComponent from "./ToolTipComponent";

function getOpacityPercentage(level) {
  if (level < 0 || level > 9) {
    throw new Error("Opacity level must be between 0 and 9");
  }
  // Map 0-9 to corresponding opacity percentages
  const opacityPercentage = 100 - level * 10; // 0 -> 100%, 9 -> 10%
  return `text-[#383838]/${opacityPercentage}`; // Return the opacityPercentage;
}

const editTagBox = () => {
  return <div>Tages</div>;
};
const PortalTagBox = withPortalHOC(editTagBox);

const List = ({
  options = [],
  selectedOptions = [],
  setSelectedOptions,
  onOptionClick,
  multiSelect = false,
  expendedList = false,
  personList = false,
  showSearch = false,
  toggleButtons = false,
  isTagList = false,
  level = 0,
  labelKey = "label",
  valueKey = "value",
  sublabelKey = "sublabel",
  colorKey = "color_code",
  refreshList,
  addButton = false,
  addButtonLabel = "Add New",
  addButtonAction = () => {},
  size = "medium",
  width = null,
  noChildren = false,
  isLoading = false,
  isEditList = false,
  inlineCrud = false,
  editListHandler = () => null,
  deleteOptionHandler = () => null,
  noKeyboardNavigation = false,
  onSearch = null,
  boxWidth = false,
  showCheckBox = false, // For showing checkbox in search box
  isCompareValue,
  handleSelectAllOptionsClick = () => {},
}) => {
  const [searchText, setSearchText] = useState("");
  const [filteredOptions, setFilteredOptions] = useState(options);
  const [toggleFilter, setToggleFilter] = useState(toggleButtons[0]);
  const [openSubmenus, setOpenSubmenus] = useState({});
  const [editOption, setEditOption] = useState(null);
  const [isAddOption, setIsAddOption] = useState(false);
  const [newOption, setNewOption] = useState(null);
  const [activeIndex, setActiveIndex] = useState(-1); // For keyboard navigation

  const optionRefs = useRef([]); // Holds refs for each option item

  const [showPalette, setShowPalette] = useState(false);
  const [selectedColor, setSelectedColor] = useState("#607791");

  const user = useRequireAuth();
  const token = user?.token;
  const orgId = user?.org_id;
  const storedData = localStorage.getItem("company_data");
  const myUserData = localStorage.getItem("myUserData");

  const usetoken = myUserData ? JSON.parse(myUserData) : null;
  const tokens = token ? token : usetoken.token;
  const companyId = storedData ? JSON.parse(storedData).company_id : null;

  console.log("options List", options);

  // Escape special regex characters in search text
  const escapeRegExp = (string) => {
    return string.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
  };

  // updating selcted toggle button
  useEffect(() => {
    if (Boolean(toggleButtons?.length && selectedOptions[0]?.toggleType))
      setToggleFilter(selectedOptions[0].toggleType);
  }, [selectedOptions]);

  // Helper function to highlight the matching text with yellow background
  const highlightText = (text, query) => {
    if (!text) return "";
    if (!query) return text;
    const regex = new RegExp(`(${escapeRegExp(query)})`, "ig");
    const parts = text?.split(regex);
    return parts?.map((part, index) =>
      regex.test(part) ? (
        <span key={index} className="bg-yellow-200">
          {part}
        </span>
      ) : (
        part
      )
    );
  };

  // Filter options based on search text and toggle filter
  useEffect(() => {
    const filterOptions = (opts) =>
      opts
        ?.filter((option) => {
          const matchesSearch = option?.[labelKey]?.toLowerCase().includes(searchText?.toLowerCase());
          const matchesToggle =
            (toggleFilter === toggleButtons[0] && option.toggleType === toggleButtons[0]) ||
            (toggleFilter === toggleButtons[1] && option.toggleType === toggleButtons[1]);
          return matchesSearch && matchesToggle;
        })
        ?.map((option) => ({
          ...option,
          ...(Boolean(option?.children?.length) && { children: filterOptions(option.children) }),
        }));
    const filtered = filterOptions(options);
    setFilteredOptions(filtered);
    setActiveIndex(-1); // Reset active index when search text changes
  }, [searchText, toggleFilter, options]);

  // Auto-scroll the active option into view when activeIndex changes
  useEffect(() => {
    if (optionRefs.current[activeIndex]) {
      optionRefs.current[activeIndex].scrollIntoView({
        behavior: "smooth",
        block: "nearest",
      });
    }
  }, [activeIndex, filteredOptions]);

  const toggleSubmenu = (optionValue) => {
    setOpenSubmenus((prev) => ({
      ...prev,
      [optionValue]: !prev[optionValue],
    }));
  };

  const handleOptionClick = (option) => {
    if (multiSelect) {
      let updatedSelection = [];

      if (isCompareValue) {
        updatedSelection = isObjectInArray2(selectedOptions, option, [isCompareValue])
          ? selectedOptions.filter((item) => item?.[isCompareValue] !== option?.[isCompareValue])
          : [...selectedOptions, option];
      } else {
        updatedSelection = isObjectInArray(selectedOptions, option)
          ? selectedOptions.filter((item) => item?.[valueKey] !== option?.[valueKey])
          : [...selectedOptions, option];
      }

      onOptionClick(updatedSelection);
    } else {
      onOptionClick([option]);
    }
  };

  // const [triggerEditTagMutation, { data: apiResponseTag }] = useEditTagMutation();

  const updateTagName = (e) => {
    // e.stopPropagation();
    // const payload = {
    //   company_id: companyId,
    //   org_id: orgId,
    //   name: newTag,
    //   id: editTag?.[valueKey],
    // };
    // triggerEditTagMutation({ payload, tokens }).then((res) => {
    //   if (res?.data?.success) {
    //     refreshList();
    //     setEditTag(null);
    //   }
    // });
  };

  // Handle keyboard navigation in search input
  const handleKeyDown = (e) => {
    if (e.key === "ArrowDown") {
      e.preventDefault();
      setActiveIndex((prevIndex) => Math.min(filteredOptions.length - 1, prevIndex + 1));
    } else if (e.key === "ArrowUp") {
      e.preventDefault();
      setActiveIndex((prevIndex) => Math.max(0, prevIndex - 1));
    } else if (e.key === "Enter") {
      e.preventDefault();
      if (filteredOptions[activeIndex]) {
        handleOptionClick(filteredOptions[activeIndex]);
      }
    }
  };

  const colors = [
    "#6B27D3",
    "#74A431",
    "#9A0D94",
    "#EE950F",
    "#00656B",
    "#D4372A",
    "#5F5E52",
    "#DB4A6B",
    "#164A79",
    "#E38BAB",
    "#310082",
    "#962729",
    "#0E8BFE",
    "#BE1176",
    "#73471B",
    "#7A518E",
    "#134E30",
    "#2F18DB",
    "#67243D",
    "#3D46F4",
    "#ED592E",
    "#879300",
    "#2792B8",
    "#BA612E",
    "#9B6F00",
    "#3F3F3F",
  ];

  const handleColorpalette = () => {
    setShowPalette((prev) => !prev);
  };

  const handleColorClick = (color) => {
    setSelectedColor(color);
    setShowPalette(false); // optionally close after selection
  };

  const getSelectAllStatus = (filteredOptions = [], selectedOptions = []) => {
    if (!filteredOptions.length) return false;

    const selectedValues = new Set(selectedOptions.map((o) => o.value));

    return filteredOptions.every((o) => selectedValues.has(o.value));
  };

  return (
    <div className={`${Boolean(width) ? `w-[${width}]` : " min-w-full w-full "}`}>
      {/* Toggle Filter Buttons */}
      {Boolean(toggleButtons?.length) && Boolean(options?.length) && (
        <div className="sticky top-0 bg-white z-10">
          <div className="flex items-center justify-center pt-2 mx-2 gap-2]">
            <ToggleSwitch
              leftEle={toggleButtons[0]}
              rightEle={toggleButtons[1]}
              toggleState={selectedOptions[0]?.toggleType ? toggleButtons[0] === selectedOptions[0].toggleType : true}
              onToggle={(isToggled) => setToggleFilter(isToggled ? toggleButtons[0] : toggleButtons[1])}
              className={"w-[155px] "}
            />
          </div>
        </div>
      )}

      {/* Search Box with Icon */}
      {level === 0 && showSearch && (onSearch || options?.length >= 8) && (
        <div className={`sticky ${Boolean(toggleButtons.length) ? "top-12" : "top-0"} bg-white z-10`}>
          <div
            className={`${size === "small" ? "py-1 " : "py-1 "} mx-2 flex items-center justify-between border-b-2 gap-2`}
          >
            <SearchIconGray />
            <input
              type="text"
              placeholder="Search..."
              autoFocus
              value={searchText}
              onChange={(e) => {
                setSearchText(e.target?.value);
                if (onSearch) onSearch(e.target?.value);
              }}
              onKeyDown={handleKeyDown} // Keyboard navigation handler
              className="w-full py-2  pl-0 border-none focus:ring-0 focus:outline-none text-sm"
            />

            {searchText.length > 0 && filteredOptions.length > 0 && showCheckBox && (
              <span>
                {/* added this checkbox, just for the filter part for now, will check for the universal approach later on , if needed */}
                <ToolTipComponent text={"Select All"} textOnly={true}>
                  <Checkbox
                    checked={getSelectAllStatus(filteredOptions, selectedOptions)}
                    onChange={() => {
                      handleSelectAllOptionsClick(filteredOptions);
                    }}
                    onClick={(e) => e.stopPropagation()}
                  />
                </ToolTipComponent>
              </span>
            )}
          </div>
        </div>
      )}

      {/* Options List */}
      {(Boolean(options?.length) || addButton) && (
        <ul className={`ps-${level * 4} ${level === 0 ? "overflow-auto max-h-60 px-2.5" : ""} thinscrollbar mb-2`}>
          {addButton && (
            <li className="relative w-full">
              {inlineCrud && isAddOption ? (
                <div
                  className={`flex items-center justify-center  ${
                    size === "small" ? "py-1 mt-1" : "py-1 mt-1"
                  } cursor-pointer text-primary rounded text-sm text-nowrap`}
                >
                  <input
                    className="w-full pl-2 py-1 rounded-md border text-base border-[#D2DAE1] text-[10px] font-400"
                    style={{ color: selectedColor }}
                    placeholder="Enter New Option"
                    value={newOption}
                    onChange={(e) => {
                      if (e.target?.value?.length <= 20) setNewOption(e.target?.value);
                    }}
                    autoFocus
                    onKeyUp={(e) => {
                      if (e.key === "Enter") {
                        addButtonAction({
                          label: newOption,
                          ...(options[0]?.[colorKey] && { color_code: selectedColor }),
                        });
                        setIsAddOption(false);
                      }
                    }}
                  />
                  <div className="absolute right-2 top-1/2 transform -translate-y-1/2 flex items-center z-10 bg-white gap-2 ">
                    {!isTagList && options[0]?.[colorKey] && (
                      <button onClick={handleColorpalette}>
                        <i
                          className="bi bi-palette-fill cursor-pointer w-[24px] h-[24px]"
                          style={{ color: selectedColor }}
                        ></i>
                      </button>
                    )}
                    <div className="h-5 w-[2px] bg-[#D2DAE1]"></div>

                    <button
                      onClick={() => {
                        addButtonAction({
                          value: newOption,
                          ...(options[0]?.[colorKey] && { color_code: selectedColor }),
                        });
                        setIsAddOption(false);
                      }}
                    >
                      <RightArrowIcon />
                    </button>
                  </div>
                  {showPalette && (
                    <FloatingList mode="vertical" xMargin={50} margin={10}>
                      <div className="fixed grid grid-cols-6 rounded-md mt-[6px] z-20 bg-white p-2 shadow-lg">
                        {predefinedColors.map((color, index) => (
                          <div
                            key={index}
                            className="w-5 h-5 rounded cursor-pointer m-2"
                            style={{ backgroundColor: color }}
                            onClick={() => handleColorClick(color, index)}
                          />
                        ))}
                      </div>
                    </FloatingList>
                  )}
                </div>
              ) : (
                <div
                  onClick={(e) => {
                    if (inlineCrud) {
                      e.stopPropagation();
                      setEditOption(null);
                      setNewOption("");
                      setIsAddOption(true);
                    } else addButtonAction();
                  }}
                  className={`flex items-center justify-center  ${
                    size === "small" ? "py-1 my-1 px-2" : "py-1 mt-1 px-2"
                  } cursor-pointer text-primary rounded hover:bg-primary-hover text-base text-nowrap`}
                >
                  <PlusIcon
                    className="mr-1"
                    fill="var(--color-primary)"
                    width={size === "small" ? "12" : "14"}
                    height={size === "small" ? "12" : "14"}
                  />
                  {addButtonLabel ? addButtonLabel : "Add New"}
                </div>
              )}
            </li>
          )}
          {filteredOptions?.length > 0 &&
            filteredOptions.map((option, index) => {
              const isActive = index === activeIndex;
              // const isSelected = isObjectInArray(selectedOptions, option);
              // const isSelected = isObjectInArray(selectedOptions, option, ["children"]);

              let isSelected;
              if (isCompareValue) {
                isSelected = isObjectInArray2(selectedOptions, option, [isCompareValue]);
              } else {
                isSelected = isObjectInArray(selectedOptions, option, ["children"]);
              }
              // If selected, apply a gray background; if active, add an outline
              const liClasses = `relative ${isSelected ? "bg-primary-active" : ""} ${isActive && !noKeyboardNavigation ? "bg-[#F0F0F0]" : ""}`;
              return (
                <li key={option?.[valueKey]} ref={(el) => (optionRefs.current[index] = el)} className="w-full relative">
                  {editOption !== null && option?.[valueKey] === editOption?.[valueKey] ? (
                    <div
                      className={`flex items-center justify-between  ${
                        size === "small" ? "py-1 my-1" : "py-2 my-1"
                      } cursor-pointer text-primary rounded text-sm text-nowrap`}
                    >
                      <input
                        className="w-full pl-2 py-1 rounded-md border text-base border-[#D2DAE1] text-[10px] font-400"
                        value={newOption !== null ? newOption : editOption?.[labelKey]}
                        style={{ color: selectedColor }}
                        placeholder="Enter Label"
                        autoFocus
                        onChange={(e) => {
                          if (e.target?.value?.length <= 20) setNewOption(e.target?.value);
                        }}
                        onKeyUp={(e) => {
                          if (e.key === "Enter") {
                            if (isTagList) editListHandler(editOption, newOption, e);
                            else
                              editListHandler(
                                editOption,
                                { value: newOption, ...(option?.[colorKey] && { color_code: selectedColor }) },
                                e
                              );
                            setEditOption(null);
                          }
                        }}
                      />
                      <div className="absolute right-2 top-1/2 transform -translate-y-1/2 flex items-center z-10 bg-white gap-2 ">
                        {!isTagList && option?.[colorKey] && (
                          <button onClick={handleColorpalette}>
                            <i
                              className="bi bi-palette-fill cursor-pointer w-[24px] h-[24px]"
                              style={{ color: selectedColor }}
                            ></i>
                          </button>
                        )}
                        <div className="h-5 w-[2px] bg-[#D2DAE1]"></div>

                        <button
                          onClick={(e) => {
                            if (isTagList) editListHandler(editOption, newOption, e);
                            else
                              editListHandler(
                                editOption,
                                { value: newOption, ...(option?.[colorKey] && { color_code: selectedColor }) },
                                e
                              );
                            setEditOption(null);
                          }}
                        >
                          <RightArrowIcon />
                        </button>
                      </div>
                      {showPalette && (
                        <FloatingList mode="vertical" xMargin={50} margin={10}>
                          <div className="fixed grid grid-cols-6 rounded-md mt-[6px] z-20 bg-white p-2 shadow-lg">
                            {predefinedColors.map((color, index) => (
                              <div
                                key={index}
                                className="w-5 h-5 rounded cursor-pointer m-2"
                                style={{
                                  backgroundColor: color,
                                  border: selectedColor === color ? "2px solid #000000" : "none",
                                }}
                                onClick={() => handleColorClick(color, index)}
                              />
                            ))}
                          </div>
                        </FloatingList>
                      )}
                    </div>
                  ) : (
                    <div
                      onClick={(e) => {
                        e.stopPropagation();
                        if (expendedList) handleOptionClick(option);
                        else {
                          if (option.children?.length) toggleSubmenu(option?.[valueKey]);
                          else handleOptionClick(option);
                        }
                      }}
                      className={`flex items-center justify-between px-2 w-full ${
                        size === "small" ? "py-1 my-2" : "py-2 my-2"
                      } cursor-pointer text-[#383838] rounded hover:bg-primary-hover ${liClasses} group`}
                    >
                      {/* Left-aligned Start Adornment and Label */}
                      <div className={`flex items-center gap-2.5 w-full ${personList ? "text-[#2999BC]" : ""}`}>
                        {multiSelect && (
                          // <input
                          //   type="checkbox"
                          //   checked={isSelected}
                          //   onChange={() => handleOptionClick(option)}
                          //   className="form-checkbox text-indigo-600"
                          //   onClick={(e) => e.stopPropagation()}
                          // />
                          <Checkbox
                            checked={isSelected}
                            onChange={() => handleOptionClick(option)}
                            onClick={(e) => e.stopPropagation()}
                          />
                        )}
                        {option.startAdornment && <span>{option.startAdornment}</span>}
                        {personList && (
                          <AvatarName
                            size="medium"
                            name={getInitials(option?.[labelKey])}
                            bgColor={"#e8ecf299"}
                            textColor={"#7C7C83"}
                            borderColor={"#ABABAC"}
                          />
                        )}
                        {!personList && !isTagList && option?.[colorKey] && (
                          <span
                            className={`w-3 h-6 rounded-md flex items-center justify-center p-1 text-xs`}
                            style={{
                              backgroundColor: `${option?.[colorKey]}`,
                              // borderLeftColor: `${option.[colorKey]}`,
                            }}
                          ></span>
                        )}
                        <div
                          className={`truncate flex flex-col ${boxWidth && "grow min-w-0"} ${
                            level > 0 ? `max-w-[calc(300px_-_${level * 4}px)]` : "max-w-[300px]"
                          } ${isTagList ? `text-[#ffffff] py-0.5 px-3 rounded-md` : ""} text-sm`}
                          style={{
                            backgroundColor: `${isTagList && option?.[colorKey]}33`,
                            border: `${isTagList && "1px solid"} ${isTagList && option?.[colorKey]}`,
                            color: isTagList && option?.[colorKey],
                            fontSize: size === "small" ? ".8rem" : ".9rem",
                          }}
                        >
                          <p className="w-full truncate">{highlightText(option?.[labelKey], searchText)}</p>
                          {option?.[sublabelKey] && (
                            <p className={`${personList ? "text-black" : "text-blue-500"} text-xs w-full truncate`}>
                              {" "}
                              {highlightText(option?.[sublabelKey], searchText)}
                            </p>
                          )}
                        </div>
                      </div>

                      {/* Right-aligned End Adornment with Ellipsis */}
                      {option.endAdornment && (
                        <span
                          className="text-sm text-gray-500 truncate"
                          style={{
                            maxWidth: "150px",
                            marginLeft: "10px",
                            whiteSpace: "nowrap",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                          }}
                        >
                          {option.endAdornment.length > 20
                            ? `${option.endAdornment.slice(0, 17)}...`
                            : option.endAdornment}
                          {option.endAdornment.length > 19 && (
                            <ToolTip text={option.endAdornment}>
                              <i className="bi bi-question-circle"></i>
                            </ToolTip>
                          )}
                        </span>
                      )}
                      <div className="flex gap-2">
                        {(isEditList || isTagList || option.isEditable) && !option.endAdornment && (
                          <span
                            className="text-sm text-gray-500 truncate invisible group-hover:visible"
                            style={{}}
                            // onClick={(e) => {
                            //   e.stopPropagation();
                            //   setEditTag(option);
                            //   setNewTag(option.[labelKey]);
                            // }}
                            onClick={(e) => {
                              e.stopPropagation();
                              if (!isTagList && !inlineCrud) editListHandler(option);
                              else {
                                setIsAddOption(false);
                                setEditOption(option);
                                setNewOption(option?.[labelKey]);
                                setSelectedColor(option?.[colorKey]);
                              }
                            }}
                          >
                            <i className="bi bi-pencil"></i>
                          </span>
                        )}
                        {option.isDeleteable && (
                          <span
                            className="text-sm text-gray-500 truncate invisible group-hover:visible"
                            style={{}}
                            onClick={(e) => {
                              e.stopPropagation();
                              deleteOptionHandler(option);
                            }}
                          >
                            <i className="bi bi-trash"></i>
                          </span>
                        )}
                      </div>
                    </div>
                  )}
                  {(openSubmenus[option?.[valueKey]] || expendedList) && Boolean(option.children?.length) && (
                    <List
                      options={option.children}
                      selectedOptions={selectedOptions}
                      onOptionClick={onOptionClick}
                      multiSelect={multiSelect}
                      expendedList={expendedList}
                      level={level + 1}
                      personList={personList}
                      refreshList={refreshList}
                      noKeyboardNavigation={noKeyboardNavigation}
                      size="small"
                      isLoading={isLoading}
                      labelKey={labelKey}
                      valueKey={valueKey}
                      sublabelKey={sublabelKey}
                      // isEditList = {isEditList}
                    />
                  )}
                </li>
              );
            })}
        </ul>
      )}
      {filteredOptions?.length === 0 && (
        <div
          className={`flex items-center justify-center px-2 mx-1 ${
            isTagList ? "py-1" : size === "small" ? "py-0" : "py-2"
          } cursor-pointer text-[#383838] rounded`}
        >
          <div className={`flex items-center justify-center gap-2 ${personList ? "text-[#2999BC]" : ""} pb-2`}>
            <span
              className={`truncate ${
                level > 0 ? `max-w-[calc(300px_-_${level * 4}px)]` : "max-w-[300px]"
              } ${isTagList ? `text-[#ffffff] py-0.5 px-3 rounded-full` : ""} text-sm`}
            >
              {isLoading ? <CircularLoader /> : "No Option Found"}
            </span>
          </div>
        </div>
      )}
    </div>
  );
};

export default List;
